import React from 'react';
import { Helmet } from "react-helmet";
import cn from 'classnames';
import { request } from '../functions/apiRequestHelper';
import { gtmPageview, gtmPush } from '../functions/gtm';
import Layout from '../components/Layout';
import Button from '../audi-ui-components/Button';
import queryString from 'query-string';
import VehicleSearchForm from "../components/VehicleSearchForm";
import {
  PATH_LOCATEADEALER
} from "../constants";

class ThreeG extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      vehicleFound: false,
      comments: null
    };
  }
  
  onClickReset = () => {
    this.setState({
      submitted: false,
      vehicleFound: false,
      comments: null
    });
  }
  
  render() {
    const { submitted, vehicleFound } = this.state;
    const query = queryString.parse(this.props.location.search);
    return (
      <Layout ui={query.ui} embedded={query.embedded}>
        <Helmet>
          <title>3G Shutdown | Audi Australia</title>
        </Helmet>

        <main className="audi-forms__page pt-3 pt-medium-5">
          
          <h2 className="aui-headline-4 mb-3">3G NETWORK SHUTDOWN VEHICLE IDENTIFICATION NUMBER (VIN) CHECKER</h2>
          
          {!submitted && <VehicleSearchForm
            vin={query.vin}
            lookupUrl={`${process.env.RAZZLE_RECALL_API}/1/service/3gcheck`}
            onLookupVin={(response, vehicle, lookupType) => {
              // console.log(response);
              this.setState({ submitted: true, vehicleFound: true, comments: response.comments });
            }}
            onLookupVinNotFound={(error, vehicle, lookupType) => {
              // console.log(error);
              this.setState({ submitted: true });
            }}
            onClickVinHelp={()=>{}}
            submitBtnText="Search"
            regoLookup
          >
            <p className="mb-5">Please enter the 17-characters of your Vehicle Identification Number (VIN), or enter your registration number and state, to find out if your vehicle is affected by the shutdown of the 3G networks by the mobile network operators in Australia.</p>
          </VehicleSearchForm>}
          
          {submitted && !vehicleFound && <div className="row mb-5">
            <div className="col-small-6 col-large-7">
              <p className="mb-3">Sorry, we couldn't find your vehicle details.</p>
              <p className="mb-5">Please contact your preferred dealer to enquire about the 3G Shutdown.</p>
              <Button variant="primary" onClick={()=>{ this.props.history.push(PATH_LOCATEADEALER); }}>Locate a dealer</Button>
              {`&nbsp;`}<Button variant="secondary" onClick={this.onClickReset}>Check another vehicle</Button>
            </div>
            <div className="col-small-1"></div>
            <div className="col-small-5 col-large-4">
              <aside className="contact-section">
                <p>
                  Service Team: <a href="tel:1300734567"><b>1300 734 567</b></a>
                  <br />Opening Hours: <b>Mon-Fri (9am-5pm)</b>
                </p>
              </aside>
            </div>
          </div>}
          
          {submitted && vehicleFound && <div className="row mb-5">
            <div className="col-small-6 col-large-7">
              <p className="mb-3">{this.state.comments}</p>
              <Button variant="secondary" onClick={this.onClickReset}>Check another vehicle</Button>
            </div>
            <div className="col-small-1"></div>
            <div className="col-small-5 col-large-4">
              <aside className="contact-section">
                <p>
                  Service Team: <a href="tel:1300734567"><b>1300 734 567</b></a>
                  <br />Opening Hours: <b>Mon-Fri (9am-5pm)</b>
                </p>
              </aside>
            </div>
          </div>}
          
        </main>
      </Layout>
    );
  }
}

export default ThreeG;
